import { render, staticRenderFns } from "./ModelSelectCard.vue?vue&type=template&id=6377b088&scoped=true"
import script from "./ModelSelectCard.vue?vue&type=script&lang=ts"
export * from "./ModelSelectCard.vue?vue&type=script&lang=ts"
import style0 from "./ModelSelectCard.vue?vue&type=style&index=0&id=6377b088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6377b088",
  null
  
)

export default component.exports